import { gql } from '@apollo/client';

export const fetchCloudSitesForTXA = gql`
  query fetchCloudSitesForTXA($id: ID!, $searchOptions: ConnectionSearchOptions, $filterOptions: FilterOption) {
    cloudSitesForTransactionAccount(id: $id, searchOptions: $searchOptions, filterOptions: $filterOptions) {
      cloudSiteId
      cloudSiteHostname
    }
  }
`;
